import { create } from "zustand";
import type { Zona } from "../../api-client/zonas/zona";
import { obtenerZonasActivas } from "../../api-client/zonas/zonas.api";

export interface ZonasState {
  actives: Zona[];

  cargarActivas: () => Promise<void>;
}

export const useZonasStore = create<ZonasState>()((set) => ({
  actives: [],

  cargarActivas: async () => {
    const response = await obtenerZonasActivas();

    if (response.isFailure) return;

    set({
      actives: response.result
    });
  }
}));
